<script>
  import { mapState } from 'vuex'
  export default {
    name: 'AutocompleteSelect',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'items'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch('signup/SET_FIELD', { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-autocomplete :placeholder="placeholder" :rules="rules" v-model="model" outlined light :label="label" :items="items"  ></v-autocomplete>
</template>
